<template>
  <div>
    <portal to="top-bar-right">
      <YButton class="btn btn-blue" @click="addTemplateImage"
        >Add New Image</YButton
      >
    </portal>
    <TemplateImagesTableWrapper></TemplateImagesTableWrapper>
  </div>
</template>

<script>
import TemplateImagesTableWrapper from '@/views/Admin/TemplateImages/TemplateImagesTableWrapper'
import AddTemplateImage from '@/views/Admin/TemplateImages/AddTemplateImage.vue'

export default {
  props: {},
  components: {
    TemplateImagesTableWrapper
  },

  methods: {
    addTemplateImage() {
      this.$modal.show(
        AddTemplateImage,
        {},
        {
          height: 'auto',
          width: '80%',
          maxWidth: 600,
          adaptive: true,
          scrollable: true
        }
      )
    }
  },
  updated() {}
}
</script>
